<template>
  <div class="bs-toast-item ${options.class}" ref="element">
    <div class="bs-toast-item__header">
      <i class="${options.icon}" if.bind="options.icon"></i>
      <strong if.bind="options.heading">${options.heading}</strong>
      <button type="button" data-dismiss="toast">&times;</button>
    </div>
    <div class="bs-toast-item__body">
      <compose view-model.bind="viewModel" view.bind="message.view" model.bind="message.model"></compose>
    </div>
  </div>
</template>
